/**
 * @name DEFAULT_NODE
 * @constant
 * @object
 * @description Default node data
 */
export const DEFAULT_NODE = {
    details: {},
    connections: []
};


/**
 * @name NODE_TYPE_PERSON
 * @constant
 * @string
 * @description Determines a node type of a person
 */
export const NODE_TYPE_PERSON = 'person';

/**
 * @name NODE_TYPE_EVENT
 * @constant
 * @string
 * @description Determines a node type of an event
 */
export const NODE_TYPE_EVENT = 'event';

/**
 * @name NODE_TYPE_ORGANIZATION
 * @constant
 * @string
 * @description Determines a node type of an organization
 */
export const NODE_TYPE_ORGANIZATION = 'organization';

/**
 * @name NODE_TYPE_PLACE
 * @constant
 * @string
 * @description Determines a node type of a place
 */
export const NODE_TYPE_PLACE = 'place';

/**
 * @name NODE_TYPES
 * @constant
 * @array
 * @description List of possible node types
 */
export const NODE_TYPES = [ NODE_TYPE_EVENT, NODE_TYPE_ORGANIZATION, NODE_TYPE_PERSON, NODE_TYPE_PLACE ];